require.register("app/graphql/MultiMutation", function(exports, require, module){
  $0
  
});

